import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { get, post, put } from '../../../utils/fetchAPI';
import { showSuccessToast } from '../../../utils/toaster-alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk, faSquarePlus } from '@fortawesome/free-solid-svg-icons';

export const ResearchTagCreate = () => {
    const [tagList, setTagList] = useState([])
    const { user } = useSelector((state) => state.auth);
    const [updatedData, setUpdatedData] = useState({})
    const [createData, setCreateData] = useState({})

    useEffect(() => {
        getTagList(user?.user?._id)
    }, [])

    const getTagList = async (doctorId = user?.user?._id) => {
        await get(`/doctor/tag/list/${doctorId}`)
            .then((res) => {
                if (res?.status == 200) {
                    setTagList(res?.data?.tags)
                    setUpdatedData({})
                    setCreateData({})
                }
            })
            .catch(() => { });
    }

    const addTag = async (doctorId, data) => {
        await post(`/doctor/tag`, {
            "doctor": doctorId,
            "name": data?.name
        })
            .then((res) => {
                if (res?.status == 200) {
                    getTagList()
                    setCreateData({})
                    showSuccessToast("Created successfully")
                }
            })
            .catch(() => { });
    }

    const updateTag = async (doctorId, updateTag) => {
        await put(`/doctor/tag/${updateTag?.id}`, {
            "doctor": doctorId,
            "name": updateTag?.name
        })
            .then((res) => {
                if (res?.status == 200) {
                    getTagList()
                    showSuccessToast("Updated successfully")
                }
            })
            .catch(() => { });
    }

    return (
        <div className="settings-list-card">
            <p className="settings-list-card__header">Research tags</p>
            <div className="settings-list-card__composer settings-list-card__composer--align-center">
                <textarea
                    className="settings-list-card__field settings-list-card__field--tag"
                    onChange={(e) => {
                        setCreateData({
                            name: e.target.value
                        })
                    }}
                    value={createData?.name || ""}
                    rows={1}
                    placeholder="Create a tag…"
                />
                <button
                    type="button"
                    className="settings-list-card__add-btn"
                    onClick={() => {
                        addTag(user?.user?._id, createData)
                    }}
                    disabled={!createData?.name?.trim()}
                    title="Add tag"
                >
                    <FontAwesomeIcon icon={faSquarePlus} size="xs" />
                </button>
            </div>
            {tagList?.length > 0 ? (
                <div className="settings-list-card__list">
                    {tagList?.map((data, index) => {
                        return (
                            <div key={index} className="settings-list-card__row">
                                <textarea
                                    className="settings-list-card__field settings-list-card__field--tag"
                                    onChange={(e) => {
                                        setUpdatedData({
                                            id: data?._id,
                                            name: e.target.value
                                        })
                                    }}
                                    value={data?._id == updatedData?.id ? updatedData?.name : data?.name}
                                    rows={1}
                                />
                                <div className="settings-list-card__actions">
                                    <button
                                        type="button"
                                        className="settings-list-card__icon-btn settings-list-card__icon-btn--save"
                                        onClick={() => {
                                            updateTag(user?.user?._id, updatedData)
                                        }}
                                        disabled={updatedData?.id != data?._id}
                                        title="Save"
                                    >
                                        <FontAwesomeIcon icon={faFloppyDisk} size="xs" />
                                    </button>
                                </div>
                            </div>
                        )
                    })}
                </div>
            ) : (
                <p className="settings-list-card__empty">No tags yet. Create one above.</p>
            )}
        </div>
    )
}
